import { render, staticRenderFns } from "./DocumentPreviewDialog.vue?vue&type=template&id=2f1a3e6c&scoped=true&"
import script from "./DocumentPreviewDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentPreviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPreviewDialog.vue?vue&type=style&index=0&id=2f1a3e6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1a3e6c",
  null
  
)

export default component.exports